// @flow
import React from 'react';

import { ROOT_ID } from 'Components/widgets/navigation/Navigation.constants';

import { type LanguagesProps } from 'Components/widgets/languages/Languages.jsx';
import { SideNavigation, type NavItem } from './SideNavigation.jsx';

type Props = {|
  backButtonLabel?: string,
  backButtonMainNavLabel?: string,
  closeMenu: () => void,
  items: Array<NavItem>,
  language?: LanguagesProps,
  navBack: () => void,
  navForward: () => void,
  panelStyles: {
    maxWidth: string,
    top: number,
    transition: string,
  },
  parentId: string,
  parentLabel?: string,
  sideNavigationPanels: Array<string>,
|};

export function SubItems(props: Props) {
  const {
    backButtonLabel,
    backButtonMainNavLabel,
    items,
    language,
    navBack,
    navForward,
    closeMenu,
    panelStyles,
    parentId,
    parentLabel,
    sideNavigationPanels,
  } = props;

  return items
    .filter(item => item.subItems && item.subItems.length)
    .map<Node>(({ label, link, subItems }) => {
      const itemId = `${label.replace(/ /g, '-').toLowerCase()}`;
      const panelProps = {
        backButtonLabel: parentId === ROOT_ID ? backButtonMainNavLabel : backButtonLabel,
        id: itemId,
        isActive:
          !!sideNavigationPanels.length &&
          sideNavigationPanels[sideNavigationPanels.length - 1] === itemId,
        isHidden: !sideNavigationPanels.includes(itemId),
        items: subItems,
        label,
        language,
        navBack,
        navForward,
        closeMenu,
        parent: parentId,
        parentLabel,
        parentLink: link,
        style: panelStyles,
      };
      return [
        <SideNavigation key={label} {...panelProps} />,
        <SubItems key={itemId} {...props} parentId={itemId} parentLabel={label} items={subItems} />,
      ];
    });
}
